import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

import { List } from '@site-mate/dashpivot-shared-library';

import { UserService } from 'app/user/user.service';

@Component({
  selector: 'cc-list-thumbnail',
  templateUrl: './list-thumbnail.component.html',
  styleUrls: ['./list-thumbnail.component.scss'],
})
export class ListThumbnailComponent {
  @Input() list: List & { itemCount: number };
  @Input() maxVisibleItems = 12;
  @Input() listIsDeployed = false;
  @HostBinding('class.selected') @Input() selected = false;
  @Output() readonly selectList = new EventEmitter<string>();
  @Output() readonly changeSelectedState = new EventEmitter<{ listId: string; selected: boolean }>();

  constructor(private readonly userService: UserService) {}

  isProjectControllerOrAbove$ = this.userService.isProjectControllerOrAbove$();
}
